import { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";

export function Splash() {
    const [show, setShow] = useState(() => !sessionStorage.getItem("homiie_splash_seen"));

    useEffect(() => {
        if (!show) return;
        const t = setTimeout(() => {
            sessionStorage.setItem("homiie_splash_seen", "1");
            setShow(false);
        }, 3000);
        return () => clearTimeout(t);
    }, [show]);

    if (!show) return null;

    return (
        <div
            data-testid="splash-screen"
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white"
        >
            <div className="animate-[fadeIn_0.5s_ease-out]">
                <Logo size={132} showText={false} />
            </div>
            <div data-testid="splash-loader" className="mt-8 flex items-center gap-1.5">
                <span className="h-2 w-2 animate-[bounce_1s_infinite] rounded-full bg-orange [animation-delay:-0.3s]" />
                <span className="h-2 w-2 animate-[bounce_1s_infinite] rounded-full bg-orange [animation-delay:-0.15s]" />
                <span className="h-2 w-2 animate-[bounce_1s_infinite] rounded-full bg-orange" />
            </div>

            <style>{`@keyframes fadeIn{from{opacity:0}to{opacity:1}}`}</style>
        </div>
    );
}
